import WideHome from "@/layouts/WideHome/WideHome.vue";
import SearchBox from "@/components/Search/SearchBox/SearchBox.vue";
import HomeCta from "@/components/HomeCta/HomeCta.vue";
import OneTrustService from "@/services/OneTrustService";
import { mapGetters } from "vuex";

export default {
    components: {
        SearchBox,
        HomeCta,
        WideHome
    },
    data() {
        return {
            layout: WideHome,
            canonical: ""
        };
    },
    metaInfo() {
        return {
            title: this.$t(`homePageMetaTitle`),
            meta: [
                {
                    name: "description",
                    content: this.$t(`homeMetaDescription`)
                },
                {
                    name: "keywords",
                    content: this.$t(`homePageMetaKeywords`)
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: this.canonical
                }
            ]
        };
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    created() {
        let activeLocale = this.currentLanguage;
        switch (activeLocale) {
            case "en":
                this.canonical = "https://www.yourdictionary.com/";
                break;
            case "es":
                this.canonical = "https://es.yourdictionary.com/";
                break;
            default:
                this.canonical = "https://www.yourdictionary.com/";
        }

        this.$emit("update:layout", this.layout);
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined") {
            // Signal that the pre-render has finished.
            setTimeout(function() {
                document.dispatchEvent(new Event("spa-render-complete"));
            }, 200);
        } else {
            // Run only on client side
            OneTrustService.setListeners(this);
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomePage.js